<template>
  <div class="job-board">
    <CModal
      id="applyjobModal"
      title="Apply Job"
      color="primary"
      centered:false
      @update:show="onShow"
      :show.sync="successModal"
      >{{ modalMessage }}</CModal
    >
    <div class="job-board-detail-component container-fluid">
      <div>
        <CRow class="d-flex justify-content-center">
          <img
            :src="fileSource.logo"
            class="rounded-circle w-100 h-100"
            style="width: 100px; height: 100px"
            @error="$event.target.src = '/img/hospital.png'"
            alt="logo"
          />
        </CRow>
      </div>
      <div class="title">
        <p>{{ organisation }}</p>
        <h5 class="label lblspan text-primary text-center">
          Location:
          <span style="color: #00000099">{{ location }} </span>
        </h5>
      </div>
      <div class="title mt-5">
        <h5 class="text-center">
          {{ title }}
        </h5>
      </div>
      <div class="detail-group">
        <div class="detail-group-item">
          <div class="label">Candidate Type</div>
          <div class="value text-left">{{ candidateType }}</div>
        </div>
        <div class="detail-group-item">
          <div class="label text-right">Candidate Level</div>
          <div class="value">{{ candidateLevel }}</div>
        </div>
      </div>

      <div class="border-line-dashed d-md-none d-lg-none"></div>

      <div class="detail-group">
        <div class="detail-group-item">
          <div class="label">Job Reference</div>
          <div class="value text-left">{{ jobReference }}</div>
        </div>
        <div class="detail-group-item">
          <div class="label text-right">Contract</div>
          <div class="value">{{ contract }}</div>
        </div>
      </div>

      <div class="border-line-dashed d-md-none d-lg-none"></div>

      <div class="detail-group">
        <div class="detail-group-item">
          <div class="label">Date created</div>
          <div class="value text-left">{{ date_created }}</div>
        </div>
        <div class="detail-group-item">
          <div class="label text-right">Expiry on</div>
          <div class="value">{{ expiryDate }}</div>
        </div>
      </div>

      <div class="border-line-dashed d-md-none d-lg-none"></div>

      <div class="action-group">
        <button
          v-if="!getSelectedJobBoard.status"
          type="button"
          class="btn btn-primary btn-block mb-3"
          @click="onApplyJob()"
        >
          Apply Now
        </button>
        <p
          v-if="getSelectedJobBoard.status && getSelectedJobBoard.status.status"
          class="text-center my-3 status"
        >
          {{ getSelectedJobBoard.status.status }}
        </p>
        <social-sharing
          :url="url"
          :title="title"
          :description="jobReference"
          inline-template
        >
          <CDropdown class="nav-dropdown px-4" add-menu-classes="pt-0">
            <template #toggler-content>
              <div class="d-flex align-items-center text">
                <CIcon name="cil-share-alt" class="color-primary" />
              </div>
            </template>
            <CDropdownItem>
              <network network="email">
                <em class="fa fa-envelope"></em> Email
              </network>
            </CDropdownItem>
            <div>
              <CDropdownItem>
                <network network="facebook">
                  <em class="fa fa-facebook"></em> Facebook
                </network>
              </CDropdownItem>
            </div>
          </CDropdown>
        </social-sharing>
      </div>
      <hr />
      <div class="text-center">
        <img
          :src="fileSource.image"
          style="width: 80%; max-height: 250px"
          @error="$event.target.src = '/img/job-image.jpg'"
          alt="job-image"
        />
      </div>
      <hr />
      <div v-html="jobDescription"></div>
    </div>
  </div>
</template>

<script>
import jobDetail from "./jobDetail.vue";
export default {
  extends: jobDetail,
};
</script>
<style lang="scss" scoped>
.lblspan {
  font-size: 16px !important;
  font-weight: 300 !important;
}
.title > p {
  color: #00626a !important;
}
.text-primary {
  color: #00626a !important;
}
.btn-primary {
  background-color: #00626a !important;
  border-color: #00626a !important;
}
</style>
